import { render, staticRenderFns } from "./CookieBannerPopup.vue?vue&type=template&id=a4391adc&scoped=true"
import script from "./CookieBannerPopup.vue?vue&type=script&lang=ts"
export * from "./CookieBannerPopup.vue?vue&type=script&lang=ts"
import style0 from "./CookieBannerPopup.vue?vue&type=style&index=0&id=a4391adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4391adc",
  null
  
)

export default component.exports